import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CATEGORIES } from "@/lib/categories";
import { ArrowUpRight } from "lucide-react";

const CategoryCard = ({ category, index }) => {
  const Icon = category.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: index * 0.06 }}
    >
      <Link
        to={`/proteger/${category.slug}`}
        className="card-lift group block bg-white p-10 lg:p-12 h-full border border-transparent"
      >
        <div className="flex items-start justify-between mb-10">
          <Icon size={28} className="text-razmek-blue" strokeWidth={1.3} />
          <span className="font-serif text-razmek-gray text-sm">
            {String(index + 1).padStart(2, "0")} / 07
          </span>
        </div>
        <h3 className="font-serif text-3xl text-razmek-dark mb-3">
          {category.label}
        </h3>
        <p className="font-sans text-sm leading-relaxed text-razmek-dark/70 min-h-[60px]">
          {category.short}
        </p>
        <div className="mt-8 flex items-center gap-2 font-sans text-[11px] tracking-[0.18em] uppercase text-razmek-blue group-hover:text-razmek-gold transition-colors">
          Conocer estrategia
          <ArrowUpRight
            size={14}
            className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </div>
      </Link>
    </motion.div>
  );
};

const StrategyCTA = () => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0.42 }}
    className="bg-razmek-dark p-10 lg:p-12 flex flex-col justify-between text-white"
  >
    <div>
      <div className="eyebrow text-razmek-gold">Estrategia integral</div>
      <h3 className="font-serif text-3xl mt-3">
        ¿No sabes por dónde empezar?
      </h3>
      <p className="font-sans text-sm leading-relaxed text-white/70 mt-3">
        Responde 7 preguntas y un asesor diseñará una hoja de ruta sin costo.
      </p>
    </div>
    <Link
      to="/precalificacion"
      className="mt-8 inline-flex items-center gap-2 self-start bg-razmek-gold hover:bg-white hover:text-razmek-dark text-white px-6 py-4 font-sans tracking-[0.16em] uppercase text-[11px] transition-all"
    >
      Comenzar diagnóstico
      <ArrowUpRight size={14} />
    </Link>
  </motion.div>
);

const SectionHeader = () => (
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
    <div className="lg:col-span-5">
      <div className="eyebrow">Áreas de práctica</div>
      <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05] text-razmek-dark">
        Siete frentes,
        <br />
        <span className="italic text-razmek-blue">un solo</span> patrimonio.
      </h2>
    </div>
    <div className="lg:col-span-6 lg:col-start-7 flex items-end">
      <p className="font-sans text-base lg:text-lg leading-relaxed text-razmek-dark/70">
        Cada categoría es una pieza de una arquitectura financiera más amplia.
        Nuestro trabajo es articularlas con coherencia para que tu patrimonio
        crezca, se proteja y trascienda.
      </p>
    </div>
  </div>
);

const CategoriesGrid = () => (
  <section className="py-24 lg:py-32 bg-razmek-alt">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <SectionHeader />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-razmek-blue/10">
        {CATEGORIES.map((cat, idx) => (
          <CategoryCard key={cat.slug} category={cat} index={idx} />
        ))}
        <StrategyCTA />
      </div>
    </div>
  </section>
);

export default CategoriesGrid;
